// @flow
// TODO need to move this to input params for transitional state
export const DATE_RANGE_PICKER_SET_DATES_ACTION = 'DATE_RANGE_PICKER/SET_DATES';

type DateRangePickerSetDatesActionType = 'DATE_RANGE_PICKER/SET_DATES';

export type ActionType = DateRangePickerSetDatesActionType;

export type DateRangePickerSetDatesAction = {
    type: DateRangePickerSetDatesActionType,
    payload: {
        arrival: ?string,
        departure: ?string
    }
};

export type Action = DateRangePickerSetDatesAction;

const ACTION_CREATORS = {
    setDateRangePickerDates(
        arrival: string,
        departure: string
    ): DateRangePickerSetDatesAction {
        return {
            type: DATE_RANGE_PICKER_SET_DATES_ACTION,
            payload: {
                arrival,
                departure
            }
        };
    }
};

export default {
    ...ACTION_CREATORS
};
